'use strict';

define('features/slp/vehicle.offer',[
  'jquery',
  'txt!./vehicle.offer.hbs',
  './vehicle.picker',
  'lib/util/langFromUrl',
  'lib/util/tda.config',
  'lib/services/offers-service',
  'lib/util/zip',
  'lib/getParameterByName',
  'lib/page-cache',
  'lib/transforms/offers.tmpl.common',
  'lib/transforms/slp.offer.comment',
  'features/favorites',
  'lib/analytics/blocks/index',
  'lib/analytics/context.add',
  'cookies',

  // side effect includes
  'Handlebars',
  'lib/helpers/offer-bundle', // provides additional side effect includes
  'lazyload'
], function (
  $,
  txtTemplateOffer,
  VehiclePicker,
  langFromUrl,
  tdaConfig,
  offersFactory,
  zip,
  getParameterByName,
  PageCache,
  xformOfferCommon,
  slpOfferComment,
  favorites,
  blocks,
  anAddContext,
  cookies
) {
  var offersService = offersFactory(tdaConfig.offers.r2_api_key);
  var __offerId = getParameterByName('offerid');
  var __tmplOffer = Handlebars.compile(txtTemplateOffer);
  var __hasRtiDealer = cookies.getItem('dealer_code_rti') === 'true';

  // new instance of VehicleOffer created via form.js
  var VehicleOffer = function (el, config) {
    this.$el = $(el);
    this.config = config;
  };

  // load invoked via form.js
  $.extend(VehicleOffer.prototype, {
    load: function () {
      this.cacheId = 'offer.results.' + __offerId; // same cacheId as on offer-details js
      this.getOffer();
      return PageCache.await(this.cacheId);
    },

    getOffer: function () {
      var self = this;
      var request = {
        tdaCode: tdaConfig.tda.code,
        zipCode: zip.getCookiedDefaultFallback(),
        offerId: __offerId,
        lang: langFromUrl()
      };

      PageCache.await(this.cacheId)
        .then(function (res) {
          if (!res.containsOffers) {
            throw new Error('no_offers');
          }
          PageCache.set('offer.results.' + __offerId + '.raw', res.offerBundle.offers[0]);
          return xformOfferCommon(res.offerBundle.offers);
        })
        .then(function (xformRes) {
          self.drawOfferCard(xformRes);
          self.listeners();
          self.favListeners();
          self.analyticsOffer(xformRes);
        })
        .catch(function (err) {
          console.error('err in raq offers-service: ', err); // eslint-disable-line no-console
          self.errorCleanUp();
        });

      if (!PageCache.hasOrPending(this.cacheId)) {
        PageCache.maybeSet(this.cacheId, offersService.offers().byOfferId(request));
      }
    },

    drawOfferCard: function (offer) {
      $(this.$el).append(__tmplOffer(this.config.vehicle)); // our 'parent' template for the XSL based one
      var offerCardXSLTmpl = Handlebars.compile($('#template-offer-card').html());
      $('#raq-offer-card', this.$el).append(offerCardXSLTmpl({ items: offer }));
      $('.lazy-v', this.$el).lazy({
        afterLoad: function ($el) {
          $el.css({ visibility: 'visible' });
        }
      });
      $('input[name="offer"]', this.$el)
        .val(slpOfferComment(PageCache.get('offer.results.' + __offerId + '.raw')));
    },

    listeners: function () {
      var self = this;
      // TODO: Remove offerBlock
      $('.js-change-vehicle', self.$el).click(function (e) {
        e.preventDefault();
        $('.component-strip-offer', self.$el).remove(); // move to card noe?
        // if user changes vehicle, need to remove the hidden offer comment
        $('#comment', self.$el).val('');
        self.analyticsOffer();
        new VehiclePicker(self.$el, self.config).load();
      });
    },

    favListeners: function () {
      var $favButton = $('.favorite-button', this.$el);
      if (__hasRtiDealer) {
        $favButton.hide();
      } else {
        favorites.markFav($favButton);
        $favButton.on('click', function favclick(e) {
          e.preventDefault();
          favorites.addRemove($favButton);
        });

        PageCache.on('favs.store', function () {
          favorites.toggleFav($favButton);
        });
      }
    },

    // we did not draw offer card, so the change-vehicle link needs to be removed
    errorCleanUp: function () {
      $('#raq-change-vehicle-link', this.$el).remove();
    },

    analyticsOffer: function (offers) {
      var $scope = $('#' + this.config.formType);
      if (offers && offers.length) {
        anAddContext($scope, blocks.offerBlock(offers[0]));
      } else {
        // outputs an 'empty' dealerBlock. // TODO: provide ability to remove blocks
        anAddContext($scope, blocks.offerBlock({}));
      }
    }
  });

  return VehicleOffer;
});

